import { component } from 'knockout-decorators'

import source from './footer.html?raw'

@component('cart-reload-footer', source)
export class CartReloadFooter {
  public reload() {
    window.location.reload()
  }
}
